import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import HomeView from './views/HomeView';
import './index.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { getSystemTemplatesAsync, getStoreTemplatesAsync } from './features/templates/TemplateReducers';
import { getProductsAsync } from './features/products/ProductsSlice';
import TemplatesPreview from './certificate-templates/TemplatesPreview';

store.dispatch(getSystemTemplatesAsync());
store.dispatch(getStoreTemplatesAsync());
store.dispatch(getProductsAsync());

const router = createBrowserRouter([
	{
		path: '/',
		element: <HomeView />,
	},
	{
		path: '/templates/:id',
		element: <TemplatesPreview />,
	},
]);

createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<Provider store={store}>
			<div className="">
				<RouterProvider router={router} />
			</div>
		</Provider>
	</React.StrictMode>
);
